import { createContext, useContext, useMemo, useState } from 'react';
import { ProfileSettingsDialog } from 'root/src/client/v2/profile/features/ProfileSettingsDialog/ProfileSettingsDialog';
const SettingsDialogContext = createContext(null);
export const useSettingsDialog = () => {
    const ctx = useContext(SettingsDialogContext);
    if (!ctx) {
        throw new Error('useSettingsDialog must be used within a SettingsDialogProvider');
    }
    return ctx;
};
// Single account-settings dialog, openable from anywhere (navbar, modals) on a chosen tab.
export const SettingsDialogProvider = ({ children }) => {
    const [open, setOpen] = useState(false);
    const [initialTab, setInitialTab] = useState(null);
    const ctx = useMemo(() => ({
        openSettings: (tab) => {
            setInitialTab(tab !== null && tab !== void 0 ? tab : null);
            setOpen(true);
        },
    }), []);
    return (<SettingsDialogContext.Provider value={ctx}>
			{children}
			<ProfileSettingsDialog open={open} onOpenChange={setOpen} initialTab={initialTab}/>
		</SettingsDialogContext.Provider>);
};
